module.exports = __webpack_public_path__ + "static/media/Image Placeholder.332011f3.svg";